module.exports = __webpack_public_path__ + "static/media/ric.bddd5550.svg";